import { useMemo } from 'react';

import { WalletInterface } from '@api';

import { useFeatureToggles } from '@shared/hooks/useFeatureToggles';

import { useWalletOptions } from '@store:web/components/common/modals/AuthModal/useWalletOptions';

import { getConnectedWallet } from './getConnectedWallet';
import { WALLET_CONNECT_TYPES, WalletConnectType } from './walletsConfig';

export const useAvailableConnectTypes = (wallets: WalletInterface[]) => {
  const featureToggles = useFeatureToggles();
  const options = useWalletOptions();
  const isEvmConnected = !!getConnectedWallet(wallets, WalletConnectType.EVM);

  const connectTypes = useMemo(() => {
    return WALLET_CONNECT_TYPES.filter((type) => {
      if (type === WalletConnectType.TON) {
        return !!featureToggles.tonConnect;
      }

      if (type === WalletConnectType.PASSKEY && isEvmConnected) {
        return false;
      }

      if (options[type]?.hide) {
        return false;
      }

      return true;
    });
  }, [featureToggles.tonConnect, options, isEvmConnected]);

  return { connectTypes };
};
